import { jsx as _jsx } from "react/jsx-runtime";
import { useWidth } from '@datapad/theming';
import { Box } from '@mui/material';
import React from 'react';
import { NarrowContactsView } from './components/NarrowContactsView.js';
import { WideContactsView } from './components/WideContactsView.js';
import { useContactsFilter } from './hooks/useContactsFilter.js';
import { useVisibleContacts } from './hooks/useVisibleContacts.js';
export function Contacts(props) {
    const { initialSelectedId, onSelectionChange } = props;
    const width = useWidth();
    const useNarrowView = width === 'xs' || width === 'sm';
    const visibleContacts = useVisibleContacts();
    const { state: filterState, actions: filterActions, applyFiltersAndSort, getUniqueFactions, } = useContactsFilter();
    const filteredContacts = React.useMemo(() => applyFiltersAndSort(visibleContacts), [applyFiltersAndSort, visibleContacts]);
    const factionOptions = React.useMemo(() => getUniqueFactions(visibleContacts), [getUniqueFactions, visibleContacts]);
    const [selectedContactId, setSelectedContactId] = React.useState(initialSelectedId);
    const selectedContact = React.useMemo(() => filteredContacts.find((c) => c.id === selectedContactId), [filteredContacts, selectedContactId]);
    const handleContactSelect = React.useCallback((contact) => {
        setSelectedContactId(contact.id);
        onSelectionChange?.(contact.id);
    }, [onSelectionChange]);
    const handleBackToList = React.useCallback(() => {
        setSelectedContactId(undefined);
        onSelectionChange?.(undefined);
    }, [onSelectionChange]);
    const viewProps = {
        contacts: filteredContacts,
        selectedContact,
        filterState,
        filterActions,
        factionOptions,
        onContactSelect: handleContactSelect,
    };
    return (_jsx(Box, { sx: { flex: 1, minHeight: 0, width: '100%', display: 'flex', flexDirection: 'column' }, children: useNarrowView ? (_jsx(NarrowContactsView, { ...viewProps, onBackToList: handleBackToList })) : (_jsx(WideContactsView, { ...viewProps })) }));
}
//# sourceMappingURL=Contacts.js.map